// Section titles and repeat notes of the flow Pages tab (flow language).
export const T = {
  en_GB: {
    startPages: "Start pages",
    endPages: "End pages",
    onceBeforeTheGoals: "shown once, before the goals",
    onceBeforeTheGoal: "shown once, before the goal",
    onceAfterTheGoals: "shown once, after the goals",
    onceAfterTheGoal: "shown once, after the goal",
    forEachGoal: "For each goal",
    goalPages: "Goal pages",
    oncePerGoal: "shown once per goal",
    forTheGoal: "shown for the goal",
    beforeThePortfolios: "before the portfolios",
    afterThePortfolios: "after the portfolios",
    afterThePagesAbove: "shown after the pages above",
    forEachPortfolio: "For each portfolio",
    oncePerPortfolioOfTheGoal: "once per portfolio of the goal",
    portfolioPages: "Portfolio pages",
    onePortfolioPerGoal: "one portfolio per goal",
  },
  nb_NO: {
    startPages: "Startsider",
    endPages: "Sluttsider",
    onceBeforeTheGoals: "vises én gang, før målene",
    onceBeforeTheGoal: "vises én gang, før målet",
    onceAfterTheGoals: "vises én gang, etter målene",
    onceAfterTheGoal: "vises én gang, etter målet",
    forEachGoal: "For hvert mål",
    goalPages: "Målsider",
    oncePerGoal: "vises én gang per mål",
    forTheGoal: "vises for målet",
    beforeThePortfolios: "før porteføljene",
    afterThePortfolios: "etter porteføljene",
    afterThePagesAbove: "vises etter sidene over",
    forEachPortfolio: "For hver portefølje",
    oncePerPortfolioOfTheGoal: "én gang per portefølje i målet",
    portfolioPages: "Porteføljesider",
    onePortfolioPerGoal: "én portefølje per mål",
  },
} as const;
